import { bool } from "prop-types";

import styled from "styled-components";

import FnrFade from "UI/FnrFade";

import ButtonDisplay from "./ButtonDisplay";

MemberPortalNavButton.propTypes = {
  show: bool,
};

export default function MemberPortalNavButton({ show }) {
  return (
    <SFnrFade show={show} top={false} left>
      <ButtonDisplay />
    </SFnrFade>
  );
}

const SFnrFade = styled(FnrFade)`
  overflow: visible !important;
  padding-right: 4px;
`;
